
import { lalaMallApi } from "./config"
const axios = require("axios")

const pageRecord = (options) => {
  return new Promise((resolve, reject) => {
    const apiUrl = `${lalaMallApi}/common/leads/track`
    axios.post(apiUrl, {
      checkPoints: options
    }).then((response)=>{
        if (response.data.code === 0) {
          resolve(response.data)
        } else {
          reject(response.data)
        }
      })
      .catch(function (error) {
        reject(error)
      })
  })
}
export {
  pageRecord,
}